import axios from "../index"

/** 获取菜单模块设置 */
export const getTerminalMenu = (params) => {
    return axios.get(`/api_v2/define/terminalMenu`, { params })
}

/**  保存菜单模块设置 */
export const saveTerminalMenuSettings = (type,params) => {
    return axios.post(`/api_v2/saveTerminalMenuSettings?type=${type}`,  params,{dataType:'json'} )
}